import { render, staticRenderFns } from "./NewCheckbox.vue?vue&type=template&id=805693da&scoped=true"
import script from "./NewCheckbox.vue?vue&type=script&lang=js"
export * from "./NewCheckbox.vue?vue&type=script&lang=js"
import style0 from "./NewCheckbox.vue?vue&type=style&index=0&id=805693da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805693da",
  null
  
)

export default component.exports